import { VignetteVariantProps } from 'common/Prose/nodeViews/Image/components/ImageVariant/Types'
import { ImageVariant } from 'common/Prose/nodeViews/Image/components/ImageVariant/ImageVariant'
import { useImageStore } from 'stores/ImageStore'
import { useCloudinary } from 'providers/CloudinaryProvider/CloudinaryProvider'
import { vignette } from '@cloudinary/url-gen/actions/effect'
import { SliderField } from './SliderField'

export const VignetteVariant = (props: VignetteVariantProps) => {
  const { variant } = props
  const imageStore = useImageStore()
  const cloudinary = useCloudinary()

  if (!cloudinary) return null

  return (
    <ImageVariant {...props}>
      <SliderField
        minValue={0}
        maxValue={200}
        step={1}
        initialValue={variant.qualifier ?? 20}
        label="Change vignette intensity"
        onChangeEnd={(value) => {
          const image = cloudinary.image(variant.sourceUrl.split('?')[0]).setDeliveryType('fetch')
          image.effect(vignette(value))
          imageStore.clearVariants()
          imageStore.createVariant({ image, url: image.toURL(), action: 'vignette', qualifier: value })
        }}
      />
    </ImageVariant>
  )
}
